import * as React from 'react';
import wrapStore from '@src/utils/wrap-store';
import KvBoxStore from '@src/business-components/kv-box/store';
import styles from './index.less';
import aos from '@src/utils/aos';
import cx from 'classnames';

const KvBox = ({ store }) => {
  store.use();
  aos.reInit();

  return (
    <div className={cx(styles.kvBox, 'section')} id="home">
      <div className={styles.kv_bg} />
      <div className={styles.root}>
        <div className={cx(styles.content)}>
          <div className={styles.logoCont}>
            <div className={styles.xsjLogo} style={{ backgroundImage: `url(${store.logo_xsj})` }} />
            <div className={styles.mult} />
            <div className={styles.gylLogo} style={{ backgroundImage: `url(${store.logo_gyl})` }}>
              {/* <div className={styles.gylIcn}  />
            <div className={styles.gylTex}>供应链平台</div> */}
            </div>
          </div>
          <div className={styles.title}>{store.title_text}</div>
          <div className={styles.intro}>{store.content_text}</div>
        </div>
        {/* <div className={styles.character}>
          <div className={styles.characterCont}>
            <div className={styles.jxjA} />
            <div className={styles.jxjB} />
            <div className={styles.jwA} />
            <div className={styles.jwB} />
            <div className={styles.jwC} />
            <div className={styles.cb} />
          </div>
        </div> */}
        {store.characterList.length > 0 && (
          <div className={styles.character}>
            <div className={styles.characterCont}>
              <div className={styles.jxjA} style={{ backgroundImage: `url(${store.characterList[0].bg})` }} />
              <div className={styles.jxjB} style={{ backgroundImage: `url(${store.characterList[1].bg})` }} />
              <div className={styles.jwA} style={{ backgroundImage: `url(${store.characterList[2].bg})` }} />
              <div className={styles.jwB} style={{ backgroundImage: `url(${store.characterList[3].bg})` }} />
              <div className={styles.jwC} style={{ backgroundImage: `url(${store.characterList[4].bg})` }} />
              <div className={styles.cb} style={{ backgroundImage: `url(${store.characterList[5].bg})` }} />
            </div>
          </div>
        )}
        <div className={styles.btn} onClick={() => store.onScrollToElement('project')}>
          {store.btn_text}
          <div className={styles.btnIcn} />
        </div>
      </div>
    </div>
  );
};

export default wrapStore(KvBox, KvBoxStore);
